/**
 * The remark plugins both markdown renderers use: GFM, plus links for the
 * IDs employees quote once the lookup resolved them (`api/lookup.ts ::
 * useIdLinks`, `lib/idLinks.ts`). Tokens that match nothing stay plain text.
 */
import { useMemo, type ComponentProps } from "react";
import type ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { useIdLinks } from "../../api/lookup";
import { remarkIdLinks } from "../idLinks";

type RemarkPlugins = NonNullable<ComponentProps<typeof ReactMarkdown>["remarkPlugins"]>;

const GFM_ONLY: RemarkPlugins = [remarkGfm];

export function useRemarkPlugins(text: string | null | undefined): RemarkPlugins {
  const links = useIdLinks(text);
  return useMemo(
    () => (links.size ? ([remarkGfm, [remarkIdLinks, { links }]] as RemarkPlugins) : GFM_ONLY),
    [links],
  );
}
